<div class="modal_content flex_between">
    <div class="modal_content--content">
        <ng-template [ngComponentOutlet]="data.component"></ng-template>
    </div>
</div>

